/* VAIRE store: product access + cart, wishlist, recently viewed.
   All persistence is localStorage under vaire_* keys. Swapping to Shopify
   means reimplementing this file's API over the Storefront cart. */
(function () {
  'use strict';

  const FREE_SHIP = 70;

  function load(key, fallback) {
    try { return JSON.parse(localStorage.getItem(key)) ?? fallback; } catch (e) { return fallback; }
  }
  function save(key, val) { try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) { } }

  const listeners = {};
  function on(evt, fn) { (listeners[evt] = listeners[evt] || []).push(fn); }
  function emit(evt, data) { (listeners[evt] || []).forEach(fn => fn(data)); }

  const products = window.VAIRE_PRODUCTS || [];
  const byId = {};
  products.forEach(p => byId[p.id] = p);

  function price(p, shadeIdx) {
    let base = p.price;
    if (p.shades && shadeIdx != null && p.shades[shadeIdx]) base += (p.shades[shadeIdx].priceDelta || 0);
    return base;
  }
  function compareAt(p, shadeIdx) {
    if (!p.compareAt) return null;
    let c = p.compareAt;
    if (p.shades && shadeIdx != null && p.shades[shadeIdx]) c += (p.shades[shadeIdx].priceDelta || 0);
    return c;
  }
  function pct(p) { return p.compareAt ? Math.round((1 - p.price / p.compareAt) * 100) : 0; }
  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(n % 1 ? 2 : 0); }

  /* ---- cart ---- */
  let cart = load('vaire_cart', []);
  function keyOf(id, shade) { return id + '::' + (shade == null ? '' : shade); }
  const Cart = {
    items() { return cart.filter(i => byId[i.id]); },
    count() { return Cart.items().reduce((a, i) => a + i.qty, 0); },
    subtotal() { return Cart.items().reduce((a, i) => a + price(byId[i.id], i.shade) * i.qty, 0); },
    add(id, shade, qty) {
      qty = qty || 1;
      const k = keyOf(id, shade);
      const ex = cart.find(i => keyOf(i.id, i.shade) === k);
      if (ex) ex.qty += qty; else cart.push({ id, shade: shade == null ? null : shade, qty, at: Date.now() });
      save('vaire_cart', cart); emit('cart', { action: 'add', id, shade });
    },
    setQty(id, shade, qty) {
      const k = keyOf(id, shade);
      const ex = cart.find(i => keyOf(i.id, i.shade) === k);
      if (!ex) return;
      ex.qty = qty;
      if (ex.qty <= 0) cart = cart.filter(i => i !== ex);
      save('vaire_cart', cart); emit('cart', { action: 'qty', id, shade });
    },
    remove(id, shade) {
      const k = keyOf(id, shade);
      cart = cart.filter(i => keyOf(i.id, i.shade) !== k);
      save('vaire_cart', cart); emit('cart', { action: 'remove', id, shade });
    },
    freeShipRemaining() { return Math.max(0, FREE_SHIP - Cart.subtotal()); },
    freeShipProgress() { return Math.min(1, Cart.subtotal() / FREE_SHIP); },
  };

  /* ---- wishlist ---- */
  let wish = load('vaire_wish', []);
  const Wish = {
    list() { return wish.filter(id => byId[id]); },
    has(id) { return wish.includes(id); },
    count() { return Wish.list().length; },
    toggle(id) {
      if (wish.includes(id)) wish = wish.filter(w => w !== id); else wish.push(id);
      save('vaire_wish', wish); emit('wish', { id });
      return wish.includes(id);
    },
  };

  /* ---- recently viewed ---- */
  let recent = load('vaire_recent', []);
  const Recent = {
    push(id) {
      recent = [id].concat(recent.filter(r => r !== id)).slice(0, 8);
      save('vaire_recent', recent);
    },
    list(excludeId) { return recent.filter(r => byId[r] && r !== excludeId); },
  };

  /* ---- helpers ---- */
  function deliveryDate() {
    const d = new Date(Date.now() + 5 * 864e5);
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  window.Store = {
    FREE_SHIP, products, byId: id => byId[id],
    price, compareAt, pct, money, deliveryDate,
    cart: Cart, wish: Wish, recent: Recent, on,
  };
})();

